import { createFileRoute } from "@tanstack/react-router";
import { FilePreviewPage } from "@client/components/doc-center/file-preview-page";

export interface FilePreviewSearch {
  page?: string;
  bbox?: string;
  blockId?: string;
  citationId?: string;
  fileMode?: "edit";
}

/** 定位深链（提案证据「第 N 页」等）：TanStack 会对纯数字串 JSON.parse，统一归一为 string */
function validateSearch(search: unknown): FilePreviewSearch {
  if (!search || typeof search !== "object") return {};
  const result: FilePreviewSearch = {};
  for (const [key, value] of Object.entries(search)) {
    if (key === "page" && (typeof value === "string" || typeof value === "number")) result.page = String(value);
    else if (key === "bbox" && typeof value === "string") result.bbox = value;
    else if (key === "blockId" && typeof value === "string") result.blockId = value;
    else if (key === "citationId" && typeof value === "string") result.citationId = value;
    else if (key === "fileMode" && value === "edit") result.fileMode = "edit";
  }
  return result;
}

export const Route = createFileRoute("/_app/file-preview/$fileId")({
  validateSearch,
  component: FilePreview,
});

function FilePreview() {
  const { fileId } = Route.useParams();
  const { page, bbox, blockId, citationId, fileMode } = Route.useSearch();
  return <FilePreviewPage fileId={fileId} startInEditing={fileMode === "edit"} {...(page ? { initialPage: page } : {})} {...(bbox ? { initialBbox: bbox } : {})} {...(blockId ? { initialBlockId: blockId } : {})} {...(citationId ? { initialCitationId: citationId } : {})} />;
}
